// extracted by mini-css-extract-plugin
export default {"sideForm":"SideForm_sideForm__fzNch"};